<div class="form-group mb-1 has-feedback">
    <!-- LABEL -->
    <label *ngIf="label" [innerHTML]="label"></label>
 
    <!-- INPUT -->
    <ng-content></ng-content>
 
    <!-- STATUS
    <span *ngIf="hasEmpty()" [ngClass]="{'m-select': isSelect, 'ban-medium': !smallIcon}"
          class="glyphicon glyphicon-ban-circle text-ban form-control-feedback"></span>
    <span *ngIf="hasSuccess()" [ngClass]="{'m-select': isSelect, 'ok-medium': !smallIcon}"
          class="glyphicon glyphicon-ok text-success form-control-feedback"></span>
    <span *ngIf="hasError()" [ngClass]="{'m-select': isSelect, 'ok-medium': !smallIcon}"
          class="glyphicon glyphicon-remove text-danger form-control-feedback"></span>
    -->

    <!-- ERRO -->
    <div *ngIf="hasError() || submittedInvalid"
          [ngClass]="{'m-error': hasError() || (hasEmpty() && submittedInvalid)}">
       <small class="text-danger">
          {{getError()}}
 
          <!-- NUM CARACTERES -->
          <small *ngIf="input.hasError('minlength') || input.hasError('maxlength')" class="pull-right text-muted">
             {{input.value.length +'/'+ (input.errors.minlength ?
                input.errors.minlength.requiredLength : input.errors.maxlength.requiredLength)}}
          </small>
       </small>
    </div>
 </div>
